import {Model} from "@bryntum/schedulerpro";

export class BoardPreferences extends Model {
  static get $name() {
    return "BoardPreferences";
  }

  static get fields() {
    return [
      { name: "key" },
      { name: "value" },
    ]
  }
}

BoardPreferences.exposeProperties();
